export default {
  idTelegram: ''
}